import axios from 'axios'

export const WS_URL = import.meta.env.VITE_WS_URL
export const wsClient = axios.create({
  baseURL: WS_URL,
})

let authInterceptor: number | null = null

export const setAuthHeaders = (tenantKey: string, token: string) => {
  if (authInterceptor != null) {
    wsClient.interceptors.request.eject(authInterceptor)
  }
  authInterceptor = wsClient.interceptors.request.use((config) => {
    config.headers.Authorization = 'Bearer ' + token
    config.headers['Tenant-key'] = tenantKey
    return config
  })
}

export const removeAuthHeaders = () => {
  if (authInterceptor != null) {
    wsClient.interceptors.request.eject(authInterceptor)
  }
}

export async function downloadAttachment(url: string, params: Record<string, string> = {}) {
  const { data, headers } = await wsClient.get<Blob>(url, {
    params,
    responseType: 'blob',
  })
  const contentDisposition = headers['content-disposition'] as string
  const filenameStartIndex = contentDisposition.indexOf('"') + 1
  const filenameEndIndex = contentDisposition.lastIndexOf('"')
  const filename = contentDisposition.slice(filenameStartIndex, filenameEndIndex)
  const downloadUrl = window.URL.createObjectURL(new Blob([data]))
  const link = document.createElement('a')
  link.href = downloadUrl
  link.setAttribute('download', filename)
  document.body.appendChild(link)
  link.click()
}

export async function openExternalLink(url: string) {
  window.open(url, '_blank')
}
